import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, ArrowRight, FileText } from "lucide-react";

const CATEGORY_LABELS = {
  pr_tips: "PR Tips",
  industry_news: "Industry News",
  case_studies: "Case Studies",
  seo: "SEO",
  digital_pr: "Digital PR",
};

/**
 * Equal-height guide card with 16:9 cover image and graceful
 * image-less fallback. Read Guide link pinned to the bottom via
 * flex-col + mt-auto on the link wrapper.
 */
export default function GuideCard({ post }) {
  const [imgError, setImgError] = useState(false);
  const hasImage = post.cover_image && !imgError;

  return (
    <Link
      to={`/guides/${post.slug || post.id}`}
      className="group flex flex-col h-full bg-white border border-[#e8e6ef] rounded-lg overflow-hidden hover:border-cobalt/30 hover:shadow-sm transition-all duration-200"
    >
      {hasImage ? (
        <div className="aspect-video overflow-hidden bg-slate">
          <img
            src={post.cover_image}
            alt={post.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            onError={() => setImgError(true)}
          />
        </div>
      ) : (
        <div className="aspect-video bg-[#f1eff5] flex items-center justify-center">
          <FileText className="w-7 h-7 text-[#c9a4f5]" />
        </div>
      )}
      <div className="flex flex-col flex-1 p-6">
        <div className="flex items-center gap-2 mb-3">
          {post.category && (
            <span className="meta-tag text-[9px]">{CATEGORY_LABELS[post.category] || post.category}</span>
          )}
          {post.published_date && (
            <span className="font-mono text-[10px] text-steel flex items-center gap-1">
              <Calendar className="w-3 h-3" /> {post.published_date}
            </span>
          )}
        </div>
        <h3 className="font-heading text-lg font-bold text-bone mb-2 group-hover:text-cobalt transition-colors">
          {post.title}
        </h3>
        {post.excerpt && (
          <p className="text-sm text-steel leading-relaxed line-clamp-2 mb-4">{post.excerpt}</p>
        )}
        <span className="inline-flex items-center gap-1 text-cobalt text-sm font-mono mt-auto group-hover:translate-x-1 transition-transform">
          Read Guide <ArrowRight className="w-3 h-3" />
        </span>
      </div>
    </Link>
  );
}